import {useShop} from "../context/ShopContext";
import {Link} from "react-router-dom";
import "./Favorites.css";


function Favorites(){


const {
favorites,
removeFavorite
}=useShop();



return(

<div className="favorites-page">


<h1>
My Favorites 🤍
</h1>



<div className="favorites-grid">


{

favorites.length===0?


<h2>
No Favorites Yet
</h2>


:


favorites.map(product=>(


<div className="favorite-card" key={product.id}>


<Link to={`/product/${product.id}`}>


<img

src={product.images?.[0]}

alt={product.name}

/>


<h2>
{product.name}
</h2>


</Link>



<p>
${product.price}
</p>



<button

onClick={()=>removeFavorite(product.id)}

>

Remove ❌

</button>


</div>


))


}


</div>


</div>

)


}


export default Favorites;